import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Target, Eye, Award } from "lucide-react";

export default function AboutPage() {
  // useEffect(() => {
  //   AOS.init({ duration: 1000, once: true });
  // }, []);

  const team = [
    {
      name: "John Smith",
      role: "CEO & Founder",
      experience: "20+ years in construction",
      image:
        "https://i.pinimg.com/736x/84/8f/3b/848f3b92a3e2a6040faccad5888f851e.jpg",
    },
    {
      name: "Sarah Johnson",
      role: "Lead Architect",
      experience: "15+ years in architecture",
      image:
        "https://i.pinimg.com/736x/a3/ae/ac/a3aeac1628cd4e9b4ead5dc43864e813.jpg",
    },
    {
      name: "Mike Davis",
      role: "Project Manager",
      experience: "12+ years in project management",
      image:
        "https://i.pinimg.com/736x/8d/95/03/8d9503a77e4c21ebf0ced6c252819a0e.jpg",
    },
    {
      name: "Lisa Wilson",
      role: "Interior Designer",
      experience: "10+ years in interior design",
      image:
        "https://i.pinimg.com/736x/f3/5d/12/f35d121e8d8d8b96b23f9b5b8829e4e0.jpg",
    },
  ];

  return (
    // <div className="min-h-screen py-20 bg-white text-gray-900 overflow-hidden">
    <div>
      <section
        className="relative h-72 md:h-96 flex items-center justify-center bg-center bg-cover overflow-hidden"
        style={{
          backgroundImage:
            "url('https://wallpaperaccess.com/full/1155149.jpg')",
        }}
      >
        {/* Dark Overlay */}
        {/* <div className="absolute inset-0 bg-black opacity-50"></div> */}

        {/* Text Content */}
        <div className="text-center  ">
          <h1 className="text-5xl font-bold mb-6 mt-15 text-white">
            About Sanctus property pvt ltd
          </h1>
          <p className="text-xl text-white max-w-3xl mx-auto">
            With over 15 years of experience in construction and real estate,
            we've built our reputation on quality, reliability, and customer
            satisfaction.
          </p>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 overflow-hidden lg:px-8 mt-5">
        {/* Header */}
        {/* <div className="text-center mb-16" data-aos="fade-down">
          <h1 className="text-5xl font-bold mb-6 text-blue-700">
            About Sanctus property pvt ltd
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            With over 15 years of experience in construction and real estate,
            we've built our reputation on quality, reliability, and customer
            satisfaction.
          </p>
        </div> */}

        {/* Our Story */}
        <section className="mb-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div data-aos="fade-right">
            <div className="inline-block">
              <h2 className="text-3xl font-bold mb-2 text-blue-700">
                Our Story
              </h2>
              <div className="h-1 w-20 bg-[#6FEF34] mx-auto mb-6 blink-underline"></div>
            </div>

            <p className="text-gray-600 mb-4">
              Founded in 2008, Sanctus property pvt ltd started as a small
              construction company with a big vision.
            </p>
            <p className="text-gray-600 mb-4">
              We've grown into a full-service construction and real estate
              company with core values of quality, integrity, and satisfaction.
            </p>
            <p className="text-gray-600">
              We’re proud to have completed over 500 projects and helped
              hundreds of families find their dream homes.
            </p>
          </div>
          <div data-aos="zoom-in">
            <img
              src="https://learn.aiacontracts.com/wp-content/uploads/2022/09/b9sxybulgr3mx0fsclvq.webp"
              alt="Sanctus property pvt ltd team at work"
              className="rounded-lg shadow-xl"
            />
          </div>
        </section>

        {/* Our Foundation */}
        <section className="mb-20">
          <div className="text-center mb-16" data-aos="fade-up">
            <div className="inline-block">
              <h2 className="text-4xl text-blue-700 font-bold mb-2">
                Our Foundation
              </h2>
              <div className="h-1 w-24 bg-[#6FEF34] mx-auto mb-4 blink-underline"></div>
            </div>

            <p className="text-xl text-gray-600">
              The principles that guide everything we do
            </p>
          </div>

          {/* Mission */}
          {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div data-aos="fade-right">
              <div className="flex items-center mb-6">
                <Target className="h-12 w-12 text-[#6FEF34] mr-4" />
                <h3 className="text-3xl font-bold text-blue-700">
                  Our Mission
                </h3>
              </div>
              <p className="text-lg text-gray-600 mb-6">
                To deliver exceptional construction and real estate services...
              </p>
              <ul className="space-y-2 text-gray-600">
                {[
                  "Exceed client expectations",
                  "Build lasting relationships",
                  "Deliver superior quality",
                ].map((item, idx) => (
                  <li key={idx} className="flex items-center">
                    <span className="w-2 h-2 bg-blue-600 rounded-full mr-3" />{" "}
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative" data-aos="zoom-in">
              <img
                src="https://www.ishn.com/ext/resources/2022/09/29/Nighttime-construction-work-Getty.jpg?1664464196"
                className="rounded-lg shadow-lg"
              />
              <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-6 rounded-lg">
                <div className="text-2xl font-bold">500+</div>
                <div className="text-sm">Projects Completed</div>
              </div>
            </div>
          </div> */}
          {/* Mission */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div data-aos="fade-right">
              <div className="flex items-center mb-6">
                <Target className="h-12 w-12 text-[#6FEF34] mr-4" />
                <h3 className="text-3xl font-bold text-blue-700">
                  Our Mission
                </h3>
              </div>

              <ul className="space-y-4 text-gray-600">
                {[
                  "Client Focus: To understand client needs and deliver high-quality buildings on time and on budget.",
                  "Operational Excellence: To provide superior construction services, exceeding expectations through exceptional performance by every team member.",
                  "Relationship Building: To establish lasting relationships with clients based on trust and exceptional performance.",
                  "Innovation & Collaboration: To be recognized for innovative and collaborative approaches, developing our team and fostering long-term relationships.",
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mt-1 mr-3 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative" data-aos="zoom-in">
              <img
                src="https://www.ishn.com/ext/resources/2022/09/29/Nighttime-construction-work-Getty.jpg?1664464196"
                className="rounded-lg shadow-lg"
                alt="Mission Image"
              />
              <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-6 rounded-lg">
                <div className="text-2xl font-bold">500+</div>
                <div className="text-sm">Projects Completed</div>
              </div>
            </div>
          </div>

          {/* Vision */}
          {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="lg:order-2" data-aos="fade-left">
              <div className="flex items-center mb-6">
                <Eye className="h-12 w-12 text-[#6FEF34] mr-4" />
                <h3 className="text-3xl font-bold text-blue-700">Our Vision</h3>
              </div>
              <p className="text-lg text-gray-600 mb-6">
                To be the leading construction and real estate company in the
                region...
              </p>
              <ul className="space-y-2 text-gray-600">
                {[
                  "Lead in innovation & sustainability",
                  "Create community-enhancing spaces",
                  "Set new construction standards",
                ].map((item, idx) => (
                  <li key={idx} className="flex items-center">
                    <span className="w-2 h-2 bg-blue-600 rounded-full mr-3" />{" "}
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="lg:order-1 relative" data-aos="zoom-in">
              <img
                src="https://eecqemvzenj.exactdn.com/wp-content/uploads/2023/06/Rigger-1024x683.jpg?strip=all&lossy=1&ssl=1"
                className="rounded-lg shadow-lg"
              />
              <div className="absolute -bottom-6 -left-6 bg-green-600 text-white p-6 rounded-lg">
                <div className="text-2xl font-bold">15+</div>
                <div className="text-sm">Years Experience</div>
              </div>
            </div>
          </div> */}

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            {/* Text Section */}
            <div className="lg:order-2" data-aos="fade-left">
              <div className="flex items-center mb-6">
                <Eye className="h-12 w-12 text-[#6FEF34] mr-4" />
                <h3 className="text-3xl font-bold text-blue-700">Our Vision</h3>
              </div>

              <ul className="space-y-4 text-gray-600">
                {[
                  "Goal-Oriented & Aspirational: To be the leading brand in construction, recognized for quality and innovation.",
                  "Focus on Impact: To design and build projects that improve people's lives.",
                  "Customer & Community Centric: To be the contractor of choice in their market, supporting staff and communities.",
                ].map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mt-[6px] mr-3 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Image Section */}
            <div className="lg:order-1 relative" data-aos="zoom-in">
              <img
                src="https://eecqemvzenj.exactdn.com/wp-content/uploads/2023/06/Rigger-1024x683.jpg?strip=all&lossy=1&ssl=1"
                className="rounded-lg shadow-lg"
                alt="Our Vision"
              />
              <div className="absolute -bottom-6 -left-6 bg-green-600 text-white p-6 rounded-lg">
                <div className="text-2xl font-bold">15+</div>
                <div className="text-sm">Years Experience</div>
              </div>
            </div>
          </div>

          {/* Core Values */}
          <div className="text-center" data-aos="fade-up">
            <div className="flex items-center justify-center mb-6">
              <Award className="h-12 w-12 text-[#6FEF34] mr-4" />
              <h3 className="text-3xl font-bold text-blue-700">
                Our Core Values
              </h3>
            </div>
            <p className="text-lg text-gray-600 mb-12 max-w-3xl mx-auto">
              These fundamental principles shape our culture and guide our
              decisions.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  icon: "🏗️",
                  title: "Quality Craftsmanship",
                  desc: "We never compromise on quality...",
                },
                {
                  icon: "🤝",
                  title: "Integrity",
                  desc: "Honest communication and ethical business practices.",
                },
                {
                  icon: "👥",
                  title: "Customer First",
                  desc: "Clients’ needs are at the center of everything.",
                },
                {
                  icon: "🌱",
                  title: "Environmental Responsibility",
                  desc: "Committed to sustainability.",
                },
                {
                  icon: "💡",
                  title: "Innovation",
                  desc: "Embracing new technologies and methods.",
                },
                {
                  icon: "⚡",
                  title: "Excellence",
                  desc: "Striving for perfection and continuous improvement.",
                },
              ].map((val, idx) => (
                <div
                  key={idx}
                  className="border rounded-lg p-6 text-center hover:shadow-xl transition-shadow bg-white"
                  data-aos="flip-up"
                >
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 text-2xl">
                    {val.icon}
                  </div>
                  <h4 className="text-xl font-semibold mb-3 text-blue-700">
                    {val.title}
                  </h4>
                  <p className="text-gray-600">{val.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Team */}
        <section>
          <div className="text-center mb-12" data-aos="fade-up">
            {/* <h2 className="text-4xl font-bold mb-4">Meet Our Team</h2> */}
            <div className="inline-block">
              <h2 className="text-4xl font-bold text-blue-700 mb-2">
                Meet Our Team
              </h2>
              <div className="h-1 w-24 bg-[#6FEF34] mx-auto mb-4 blink-underline"></div>
            </div>

            <p className="text-xl text-gray-600">
              Our experienced professionals are dedicated to bringing your
              vision to life
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {team.map((member, index) => (
              <div
                key={index}
                className="text-center border rounded-lg p-6 hover:shadow-xl transition-shadow"
                data-aos="zoom-in-up"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-32 h-32 rounded-full mx-auto mb-4 object-cover"
                />
                <h3 className="text-lg font-semibold">{member.name}</h3>
                <div className="text-blue-600 font-medium mb-2">
                  {member.role}
                </div>
                <p className="text-gray-600">{member.experience}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
